import { Translation } from '../../ts/interfaces/translation.interface';

const info: Translation = {
  title: 'Info',
  noTabsFound: 'No tabs found. Create a new tab to get started.',
  noTabsTitle: 'No Tabs Found',
};
export default info;
